import { PreviewBatch } from '@dadohr/shared/domainTypes/experiencePreview';
import { channelToKey } from '../../../../../services/channels';

export const previewBatchToKey = (b: PreviewBatch, index?: number) =>
  `${b.actorKey}-${b.channels
    .map(channelToKey)
    .join('---')}-${b.ts.toMillis()}-${index || Math.random()}`;
